import { shallow } from "zustand/shallow";

import useYardActionEvents from "@hsl/core/hooks/useYardAnalyticsEvents";

import useTranslation from "../../hooks/useTranslation";
import useExplorerStore from "../../store/store";
import Select from "../Select";

interface Props {
    className?: string;
    buttonContainerClassName?: string;
}

const GroupBySelector = ({ className, buttonContainerClassName }: Props) => {
    const T = useTranslation();
    const { groupEvent } = useYardActionEvents();
    const { applyGroupBy, groupOptions, groupBy } = useExplorerStore(
        ({ config: { groupOptions }, applyGroupBy, groupBy }) => ({
            groupOptions,
            applyGroupBy,
            groupBy,
        }),
        shallow,
    );

    const handleGroupBy = (prop: string) => {
        groupEvent(groupOptions.find((o) => o.prop === prop)?.label ?? "");
        applyGroupBy(prop);
    };

    if (!groupOptions) return null;

    return (
        <Select<string>
            label={`${T("Group by").result}:`}
            value={groupBy}
            options={groupOptions.map(({ label, prop, key }) => ({
                label,
                key,
                value: prop,
            }))}
            className={className}
            buttonContainerClassName={buttonContainerClassName}
            onChange={handleGroupBy}
        />
    );
};

export default GroupBySelector;
